import React from 'react';
import "./list_gaia.scss";
import { Button, ButtonType } from "components/common/Button.component";
import { PencilIcon, Trash2Icon } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";
import { Tooltip } from "components/tooltip/Tooltip";

export const ListWithActions = (props) => {

    let headerList = props.header ? props.header.map((header, index) => {

        let sortIconClass = header.sortable && header.sortOrder ? " sort-arrow sort-arrow-" + header.sortOrder : "";

        return (<div className={header.class}
                     key={header.value}
                     onClick={header.sortable ? props.sortHandle.bind(null, index) : null}>
            {props.translate(header.text)}
            <div className={sortIconClass}/>
        </div>);
    }) : [];

    let listElements = props.header ? props.values.map((item, rowIndex) => {
        let row = props.header.map((column) => {
            const cellValue = item[column.value];
            const hasTooltip = typeof cellValue === 'string' && cellValue !== '';
            const tooltipId = "list-cell-tooltip-" + rowIndex + "-" + column.value;

            return (<div className={column.class + " align-self-center cropped-text py-3"}
                         key={column.value + "-" + item.substituteId + item.userId}
                         data-tip={hasTooltip ? "" : undefined}
                         data-for={hasTooltip ? tooltipId : undefined}>
                {cellValue}
                {hasTooltip && <Tooltip id={tooltipId} content={() => cellValue}/>}
            </div>);
        });

        return (<div className="row" key={item.substituteId + "-" + item.version}>
            {row}
            {props.showActions &&
                <div className="col-md-1 d-flex justify-content-end py-3">
                    <Button type={ButtonType.GHOST}
                            iconOnly={true}
                            icon={<PencilIcon size={ICON_SIZE.MEDIUM}/>}
                            onClick={(e) => props.editRow(rowIndex, e)}
                            ariaLabel={props.translate("workflows.edit")}
                            tooltip={{id: "list-edit-tooltip-" + rowIndex, content: () => props.translate("workflows.edit")}}
                    />
                    <Button type={ButtonType.GHOST}
                            iconOnly={true}
                            icon={<Trash2Icon size={ICON_SIZE.MEDIUM}/>}
                            onClick={(e) => props.deleteRow(rowIndex, e)}
                            ariaLabel={props.translate("workflows.delete")}
                            tooltip={{id: "list-delete-tooltip-" + rowIndex, content: () => props.translate("workflows.delete")}}
                    />
                </div>
            }
        </div>);
    }) : [];

    let scrollList = function (event) {
        if ((parseInt((event.target.scrollTop + event.target.offsetHeight + 1), 10) >= event.target.scrollHeight)) {
            if (props.scrollAtBottom)
                props.scrollAtBottom();
        }
    };

    return (
        <div className="actions-list">
            {props.header &&
                <div className="row header-row mx-0">
                    {headerList}
                    {props.showActions && (
                        <div className="col-md-1 text-right col-action-buttons">
                            {props.translate("substitutes.headers.action")}
                        </div>
                    )}
                </div>
            }

            <div className={`main-panel radius-4 ${props.values.length === 0 ? 'd-flex align-items-center justify-content-center' : ''}`} onScroll={scrollList}>
                {props.values.length > 0 ?
                    listElements
                    :
                    <h3 className="w-100 text-center m-0">
                        {props.translate("substitutes.noMatches")}
                    </h3>
                }
            </div>
        </div>
    );
};

export default ListWithActions;
